/**
 * Type guard checks if an object has values (not null or undefined) for the given keys
 *
 * NOTE: shallow check only
 *
 * @returns true if the object has values for all the given keys, and typescript will know that the
 * values are defined
 */

/** Type guard checks is all if an array's elements exist (are not null | undefined)
 *
 * @returns true if none of the elements are null or undefined
 */
export const hasElements = <const T extends unknown[]>(
  arr: T,
): arr is { [i in keyof T]: Exclude<T[i], null | undefined> } => {
  return arr.every((arg) => arg != null);
};

export const isInSet = <T, E>(set: Set<T>, el: E): el is T & E => {
  return set.has(el as unknown as T);
};
